import { render, staticRenderFns } from "./EnvioModal.vue?vue&type=template&id=97627fcc&scoped=true"
import script from "./EnvioModal.vue?vue&type=script&lang=js"
export * from "./EnvioModal.vue?vue&type=script&lang=js"
import style0 from "./EnvioModal.vue?vue&type=style&index=0&id=97627fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97627fcc",
  null
  
)

export default component.exports